import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../shared/services/alert.service';
import {MainBannerSliderService} from '../../shared/services/main-banner-slider.service';

@Component({
    selector: 'app-main-banner-slider',
    templateUrl: './main-banner-slider.component.html',
    styleUrls: ['./main-banner-slider.component.scss']
})
export class MainBannerSliderComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    mainBannerSliders = [];
    onFileChanged: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private mainBannerSliderService: MainBannerSliderService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-main-banner-slider').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'heading': ['']
        });
        this.get();
    }


    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    search() {
        const params = {
            'heading': (this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            heading: (this.searchForm && this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.mainBannerSliderService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.mainBannerSliderService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.mainBannerSliders = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.mainBannerSliders = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    onFileChange(e, type, data) {
        this.onFileChanged = e;
        this.mainBannerSliderService.fileUploadAdmin({
            'type': type,
            'fileType': 'NORMAL',
            'main_banner_slider_id': data.id
        }, this.onFileChanged).subscribe(data => {
            if (type === 'MAIN_BANNER_SLIDER') {
                if (data) {
                    this.get();
                }
            }
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openMainBannerSlider(data) {
        window.open(data['main_banner_slider']['url'], '_blank');
    }

    delete(id) {
        this.mainBannerSliderService.delete(id).subscribe(data => {
            this.get();
        });
    }
}
